<template>
  <v-col cols="12" class="mt-10 pt-3 pb-2 collective-article-info">
    <v-tooltip bottom max-width="390" content-class="custom-tooltip sand large">
      <template v-slot:activator="{ on, attrs }">
         <span
             v-bind="attrs"
             v-on="on">
           <span class="ml-3 heavy">{{ $t('sl.collectiveArticles.collectiveArticle') }}</span>
           <span class="icon-informationen grey--text ml-3"></span>
         </span>
      </template>
      <span v-html="$t('sl.collectiveArticles.tooltipSettings_' + $store.state.smartLogisticSettings.model)"></span>
    </v-tooltip>
    <v-checkbox v-model="showResidents" label="Bewohner einblenden"
                class="show-resident-checkbox hide-v-massages" :class="{'active': showResidents}"></v-checkbox>
  </v-col>
</template>
<script>
import {mapGetters} from "vuex";

export default {
  name: 'OrderSuggestionCollectiveArticleInfo',

  computed: {
    ...mapGetters({
      'showResidentsInCollectiveArticles': 'smartLogisticOrderSuggestion/isShowResidentsInCollectiveArticles',
    }),
    showResidents: {
      get() {
        return this.showResidentsInCollectiveArticles;
      },
      set(value) {
        this.$store.commit('smartLogisticOrderSuggestion/setShowResidentsInCollectiveArticles', value)
      }
    }
  },
}
</script>

<style lang="scss">
@import "@/scss/settings/color";

.collective-article-info {
  border-radius: 10px;
  background: transparentize($color-darkergrey, 0.6);
  margin-bottom: 4px;

  .icon-informationen {
    position: relative;
    top: 1px;
  }
}

.show-resident-checkbox {
  display: inline-block;
  float: right;
  margin: 0;
  padding: 0;
  opacity: 0.7;

  label {
    opacity: 0.5;
  }
  &.active {
    opacity: 1;

    label {
      opacity: 1;
    }
  }

  .v-input__slot {
    margin-bottom: 0 !important;
  }
}
</style>
